import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { useAuth } from '@/src/components/AuthContextProvider'
import { Button } from '@/src/components/ui/button'
import { ProjectEdit } from '@/src/components/manage/projects/ProjectEdit'
import { PERMISSIONS } from '@/permission.config'
import { useTranslation } from '@/src/i18n/client' 

export const Route = createFileRoute('/_manage/manage/projects/new')({
  component: ProjectNewPage,
})

function ProjectNewPage() {
  const { t } = useTranslation('manage');
  const navigate = useNavigate()
  const { permissions, isAdmin } = useAuth()
  
  // Check permission client-side
  useEffect(() => {
    const hasAccess = permissions.includes(PERMISSIONS.PROJECTS_MANAGE) || permissions.includes('*') || isAdmin
    if (!hasAccess) {
      navigate({ to: '/not-permitted' })
    }
  }, [permissions, isAdmin, navigate])

  const handleSaveSuccess = () => {
    navigate({ to: '/manage/projects' })
  }

  const handleCancel = () => {
    navigate({ to: '/manage/projects' })
  }

  return (
    <div className="flex flex-col h-full">
      <AdminToolbar>
        <AdminToolbar.Left>
          <AdminToolbar.Title>{t('projects.newProject')}</AdminToolbar.Title>
        </AdminToolbar.Left>
        <AdminToolbar.Right>
          <Button variant="outline" size="sm" onClick={handleCancel}>
            {t('cancel')}
          </Button>
        </AdminToolbar.Right> 
      </AdminToolbar>
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto">
          <ProjectEdit 
            id=""
            isNew={true}
            isLoading={false} 
            callbackUrl="/manage/projects"
            onSaveSuccess={handleSaveSuccess}
          />
        </div>
      </div>
    </div>
  )
}
